import React, {useMemo, useState} from "react";
import PropTypes from "prop-types";

//redux:
import {useDispatch, useSelector} from "react-redux";
// import {mediaItemPageActions} from "../../../redux/MediaItemPage/mediaItemRedux";

//components:
// import {CustomTooltip} from "../../../widgets";
// import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
// import CloseIcon from "@material-ui/icons/Close";
// import SearchIcon from "@material-ui/icons/Search";
import CircularProgress from "@material-ui/core/CircularProgress";

//helpers:
import {useTranslation} from "react-i18next";
import {sortHits} from "../MediaDashboardLogic";

const SearchBarResults = ({showSuggestion, handleMatchClick, currentRefinement, hits, searching}) => {
    const {t} = useTranslation();
    const [selectedResult, setSelectedResult] = useState(null);

    const unpackedHits = useMemo(() => (currentRefinement && hits.length ? sortHits(hits) : []), [
        hits,
        currentRefinement,
    ]);

    //redux:
    //actions:

    //store:
    const {isConceptualSearch = false} = useSelector(state => state.mediaItemPage);

    return (
        <div
            className={`video_searchbar_results custom-scroll-area ${
                showSuggestion && !isConceptualSearch ? "drop-down" : ""
            }`}
        >
            <div className={"list-group list-group-flush"}>
                {useMemo(
                    () =>
                        searching ? (
                            <div className="m-auto">
                                <CircularProgress />
                            </div>
                        ) : unpackedHits?.length ? (
                            unpackedHits.map(({start, text}, i) => {
                                if (i === 0 && selectedResult === null) {
                                    setSelectedResult(i);
                                    handleMatchClick(start, text);
                                }
                                const isActive = selectedResult === i;
                                return (
                                    <button
                                        key={i}
                                        className={`list-group-item list-group-item-action${
                                            isActive ? " bg-light" : ""
                                        }`}
                                        onClick={() => {
                                            setSelectedResult(i);
                                            handleMatchClick(start, text);
                                        }}
                                    >
                                        {start && typeof start === "string" ? (
                                            <span className="text-primary">
                                                {start.replace(/\.\d+/, "")}
                                                <span className="mx-4">-</span>
                                            </span>
                                        ) : null}
                                        {text ? (
                                            <span
                                                className="text-muted"
                                                dangerouslySetInnerHTML={{
                                                    __html: text,
                                                }}
                                            />
                                        ) : null}
                                    </button>
                                );
                            })
                        ) : (
                            <div className="text-muted p-5">{t("VIDEOPAGE.SEARCHBAR.NOT_FOUND")}</div>
                        ),
                    [selectedResult, searching, currentRefinement]
                )}
            </div>
        </div>
    );
};

SearchBarResults.propTypes = {
    showSuggestion: PropTypes.bool,
    handleMatchClick: PropTypes.func,
};

export default SearchBarResults;
